// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mqYa","badges":"styles_badges__3rgv7"};